import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Injectable} from "@angular/core";
import {CookieService} from "./CookieService";
import {AuthorizationService} from "../../core/authorization/AuthorizationService";


@Injectable({providedIn: 'root'})
export class ConfigurationService {


  constructor(protected http: HttpClient,private cookieService:CookieService,private  authorizationService: AuthorizationService) {
  }
   publicUrlList=["/","/authentication/side-register"];
  isRequestOfPublicScreen():boolean{
    const fullUrl = window.location.href;
    const baseUrl = window.location.origin;
    const pathOnly = fullUrl.replace(baseUrl, '');
    return this.publicUrlList.includes(pathOnly);
  }

  initConfig() {
    return new Promise((resolve, reject) => {
      const hostUrl = window.location.origin.replace(/:\d+$/, '');
      this.http.get<any>(hostUrl + environment.configurationUrl).subscribe({
        next: (res) => {
          res=res.data;
          if (res) {

            if (res.apiUrl) {
                environment.apiUrl = res.apiUrl;
            }

            if (res.loginPage) {
              environment.loginPage = res.loginPage;
            }
            if (res.logoutPage) {
              environment.logoutPage = res.logoutPage;
            }

            if (res.logoLight) {
              if(res.logoLight.startsWith("http") || res.logoLight.startsWith("ftp")){
                environment.logoLight = res.logoLight;
              }else{
                environment.logoLight = 'data:image/png;base64,'+res.logoLight;
              }
            }

            if (res.logoDark) {
              if(res.logoDark.startsWith("http") || res.logoDark.startsWith("ftp")){
                environment.logoDark = res.logoDark;
              }else{
                environment.logoDark = 'data:image/png;base64,'+res.logoDark;
              }
            }

            if (res.primaryColor) {
              environment.primaryColor = res.primaryColor;
            }

            if (res.primaryColorDim) {
              environment.primaryColorDim = res.primaryColorDim;
            }

            if (res.secondaryColor) {
              environment.secondaryColor = res.secondaryColor;
            }

            if (res.secondaryColorDim) {
              environment.secondaryColorDim = res.secondaryColorDim;
            }
            if (res.tertiaryColor) {
              environment.tertiaryColor = res.tertiaryColor;

              document.documentElement.style.setProperty('--mat-sys-primary', `${environment.primaryColor}`);
              document.documentElement.style.setProperty('--mat-sys-primary-fixed-dim', `${environment.primaryColorDim}`);
              document.documentElement.style.setProperty('--mat-sys-secondary', `${environment.secondaryColor}`);
              document.documentElement.style.setProperty('--mat-sys-secondary-fixed-dim', `${environment.secondaryColorDim}`);
              document.documentElement.style.setProperty('--mat-sys-tertiary', `${environment.tertiaryColor}`);
            }
            this.authorizationService.initConfig().then(authResult => {
              resolve(true);
            }).catch(err => {
              resolve(false);
            });
          } else {
            resolve(false);
          }
        },
        error: (err) => resolve(false)
      });
      this.http.get<any>(hostUrl + environment.chatServiceConfigurationUrl).subscribe({
        next: (res) => {
          if (res && res.data) {
            res = res.data;
            environment.chatApiUrl = res.endsWith('/') ? res.slice(0, -1) : res;
          }
        },
        error: (err) => resolve(false)
      });
    });
  }

}
